import React, { useState, useContext } from 'react';
import { func, array } from 'prop-types';
import { AppContext } from '../../../../../context/listingsContext';
import { CarouselContext } from '../../../../sc_tiles_carousel';
import { changeActiveSubcategoryContext, trackScFilter } from '../../../sc_tile/utils';
import Header from '../shared/header';
import Footer from '../shared/footer';
import List from '../shared/list';

const ScListModal = ({ close, items }) => {
    const [selected, setSelected] = useState('');
    const { setCollapseCarousel } = useContext(CarouselContext);
    const { dispatch, query, filter: { subCategory } } = useContext(AppContext);

    const onSelect = (item) => {
        setSelected(item.id);
    };

    const onApply = () => {
        setCollapseCarousel(true);
        changeActiveSubcategoryContext({ subCategory, selected, dispatch });
        const selectedSc = items.find((sc) => sc.id === selected) || {};
        const { alias, id } = selectedSc;
        trackScFilter(alias, id);
        window.location.href = selectedSc.url;
        close();
    };

    const onClear = () => {
        setSelected('');
    };

    return (
        <>
            <Header close={close} params={{ query }} titleKey="search_perseus.subcategory_tiles.view_all.title"/>
            <List items={items} selected={selected} onSelect={onSelect}/>
            <Footer setSelected={setSelected} onApply={onApply} onClear={onClear} className="hide-shadow"/>
        </>
    );
};

ScListModal.propTypes = {
    close: func,
    items: array
};

export default ScListModal;
